<template>
  <div class="row justify-content-center">
    <div class="col-lg-5 col-md-8" v-if="showLogin">
      <div class="card bg-secondary shadow border-0">
        <div class="card-body px-lg-5 py-lg-5">
          <h2>Employers:</h2>
          <h4 class="text-muted ">Login/Sign Up for job board postings, contacting, detailed filtering and more to support your hiring needs!</h4>
          <br>
          <h2>Orgs/Agencies:</h2>
          <h4 class="text-muted ">Login if you already have an account or contact us at hello@findpotential.org to make a new account.</h4>
        </div>
      </div>
    </div>
    <div class="col-lg-5 col-md-8" v-if="showLogin">
      <div class="card bg-secondary shadow border-0">
        <div class="card-body px-lg-5 py-lg-5" id="login-card">
          <div class="text-center text-muted mb-4">
            <div class="text-muted text-center mt-2 mb-3">Sign in or Create an Account with</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import firebase from "firebase";
import * as firebaseui from "firebaseui";

window.$ = window.jQuery = require("jquery");

// FirebaseUI config.
const uiConfig = {
  signInSuccessUrl: "/dashboard",
  signInOptions: [
    // Leave the lines as is for the providers you want to offer your users.
    firebase.auth.GoogleAuthProvider.PROVIDER_ID,
    firebase.auth.EmailAuthProvider.PROVIDER_ID
    //firebase.auth.PhoneAuthProvider.PROVIDER_ID,
  ],
  // tosUrl and privacyPolicyUrl accept either url string or a callback function.
  // Terms of service url/callback.
  tosUrl: function() {},
  // Privacy policy url/callback.
  privacyPolicyUrl: function() {}
};

export default {
  name: "login",
  data() {
    return {
      email: "",
      password: "",
      hasError: true,
      errorMsg: "",
      showLogin: true,
      publicPath: process.env.BASE_URL
    };
  },
  mounted() {
    // Initialize the FirebaseUI Widget using Firebase.
    var ui = new firebaseui.auth.AuthUI(firebase.auth());
    // The start method will wait until the DOM is loaded.
    ui.start("#login-card", uiConfig);
  }
};
</script>

<style>
</style>
